import {isNonEmptyString} from 'ramda-adjunct';

const isTruncated = (element: Element): boolean => element.scrollWidth > element.clientWidth;

/**
 * Returns the full text of the outermost horizontally-truncated descendants of
 * a cell, or null when nothing inside the cell is actually clipped. Only the
 * outermost truncated elements are read so nested truncated children don't
 * duplicate their text in the result.
 */
export const getTruncatedCellText = (cell: HTMLElement): string | null => {
  const truncatedElements = Array.from(cell.querySelectorAll('*')).filter(isTruncated);

  const outermostElements = truncatedElements.filter(
    (element) => !truncatedElements.some((other) => other !== element && other.contains(element))
  );

  const texts = outermostElements
    .map((element) => element.textContent?.trim())
    .filter(isNonEmptyString);

  return texts.length > 0 ? texts.join(' ') : null;
};
